import * as turf from '@turf/turf';
import mapboxgl from 'mapbox-gl';


const sources_ids = ['sourceCommoditiesCarPark'];
const layers_ids = ['layerCommoditiesCarPark_Polygons'];
var markers = [];
var marker_img = '<svg width="14" height="14" viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M775.321 445.351C772.747 445.351 770.105 445.721 767.463 446.446L737.602 454.672L706.6 379.14C697.814 357.743 671.849 340.333 648.72 340.333H358.543C335.411 340.333 309.449 357.743 300.666 379.14L269.702 454.566L240.212 446.443C237.573 445.718 234.931 445.348 232.356 445.348C218.242 445.348 208 456.13 208 470.981V488.583C208 505.92 222.108 520.028 239.445 520.028H242.824L237.819 532.219C229.658 552.093 223.015 585.752 223.015 607.246V757.296C223.015 774.633 237.123 788.741 254.461 788.741H295.529C312.866 788.741 326.974 774.633 326.974 757.296V719.826H680.286V757.296C680.286 774.633 694.394 788.741 711.731 788.741H752.794C770.131 788.741 784.239 774.633 784.239 757.296V607.249C784.239 585.758 777.596 552.099 769.435 532.222L764.43 520.031H768.229C785.566 520.031 799.674 505.923 799.674 488.586V470.984C799.677 456.133 789.432 445.351 775.321 445.351ZM292.244 502.952L339.148 388.707C344.402 375.908 360.019 365.434 373.855 365.434H633.409C647.244 365.434 662.861 375.905 668.115 388.707L715.019 502.952C720.271 515.751 713.252 526.225 699.417 526.225H307.849C294.011 526.222 286.992 515.751 292.244 502.952ZM396.946 647.46C396.946 654.379 391.283 660.035 384.37 660.035H295.27C288.351 660.035 282.692 654.376 282.692 647.46V604.701C282.692 597.785 288.351 592.125 295.27 592.125H384.37C391.283 592.125 396.946 597.785 396.946 604.701V647.46ZM723.726 647.46C723.726 654.379 718.063 660.035 711.15 660.035H622.051C615.138 660.035 609.475 654.376 609.475 647.46V604.701C609.475 597.785 615.138 592.125 622.051 592.125H711.15C718.063 592.125 723.726 597.785 723.726 604.701V647.46Z" fill="white"/><path d="M247.331 11H51.6698C23.1778 11 0 34.1816 0 62.6698V258.335C0 286.827 23.1816 310.009 51.6698 310.009H130.216V768.833C130.216 779.484 138.847 788.115 149.499 788.115C160.15 788.115 168.781 779.484 168.781 768.833V310.013H247.331C275.823 310.013 299.001 286.831 299.001 258.339V62.6737C299.001 34.1816 275.823 11 247.331 11ZM203.016 173.233C191.762 183.364 175.187 188.501 153.752 188.501H125.418C122.017 188.501 119.248 191.274 119.248 194.675V242.454C119.248 247.645 115.025 251.864 109.834 251.864H88.3764C83.1816 251.864 78.9625 247.641 78.9625 242.454V78.5703C78.9625 73.3756 83.1855 69.1527 88.3764 69.1527H142.43C178.237 69.1527 191.604 74.548 202.588 83.8692C214.173 93.6995 220.042 108.755 220.042 128.628C220.038 148.046 214.315 163.048 203.016 173.233Z" fill="white"/><path d="M172.345 108.72C167.115 104.771 157.864 102.766 144.852 102.766H125.419C122.017 102.766 119.248 105.535 119.248 108.932V148.199C119.248 151.597 122.017 154.366 125.419 154.366H137.061C141.338 154.366 148.249 154.05 152.464 153.66C156.556 153.286 168.106 151.612 172.345 148.412C177.432 144.563 180.012 137.906 180.012 128.631C180.012 119.268 177.432 112.569 172.345 108.72Z" fill="white"/></svg>';

export const get_ids = () => {
    // Get all source ids
    var sources = [];
    sources_ids.forEach(source_id => {
        sources.push({ id: source_id });
    })
    // Get all layer ids
    var layers = [];
    layers_ids.forEach(layer_id => {
        layers.push({ id: layer_id });
    })

    return {
        sources: sources,
        layers: layers,
        markers: markers,
    }
}


export const get_data = (capacity) => {
    // Set map data
    var map_data = {
        sources: [],
        layers: [],
        markers: [],
        bbox: null
    }

    // Check needed data
    if (!capacity?.context?.commodities?.parking?.items || !capacity.context.commodities.parking.items.length > 0) {
        return map_data
    }

    // Preset layer data
    var layer_data = {
        type: 'FeatureCollection',
        features: [],
    };

    // Add data
    for (var i = 0; i < capacity.context.commodities.parking.items.length; i++) {
        var item = capacity.context.commodities.parking.items[i];
        var item_marker_coords = null;
        // Generate polygon
        if (item?.type === "way" && item?.coords && item.coords.length > 3 && item.coords[0].length === 2 && item.coords[0][0] === item.coords[item.coords.length - 1][0] && item.coords[0][1] === item.coords[item.coords.length - 1][1]) {
            layer_data.features.push({
                type: "Feature",
                properties: item?.properties || null,
                geometry: {
                    type: "Polygon",
                    coordinates: [item.coords],
                }
            });
            try {
                var center = turf.centroid(turf.polygon([item.coords]));
                item_marker_coords = center?.geometry?.coordinates || null;
            } catch (error) {
                item_marker_coords = null;
            }
        }
        // Generate point
        else if (item?.type === "node" && item?.coords && item.coords.length === 2) {
            layer_data.features.push({
                type: "Feature",
                properties: item?.properties || null,
                geometry: {
                    type: "Point",
                    coordinates: item.coords,
                }
            });
            item_marker_coords = item.coords;
        }
        // Generate marker
        if (item_marker_coords !== null && item_marker_coords.length === 2) {
            var title = "Stationnement";
            var title_txt = '<span style="color:#062134;font-size:15px;font-weight:700"><strong>' + title + '</strong></span>';
            var infos = [
                { label: "Nombre de places", value: item?.properties?.slots || "NC" },
                { label: "Payant", value: item?.properties?.fee === "yes" ? "Oui" : item?.properties?.fee === "no" ? "Non" : "NC" },
                { label: "Type", value: item?.properties?.category || "NC" },
            ]
            var infos_txt = infos.map(info => { return ('<br /><span style="font-size:12px;font-weight: 600;color: grey;">' + info.label + ' :</span><br /><span style="color:#062134;font-weight:500;">' + info.value + '</span>') }).join('');
            var marker_label = item?.properties?.slots ? item.properties.slots : "";
            var el = document.createElement('div');
            el.className = 'marker';
            el.innerHTML = '<div style="cursor:pointer;padding:3px 8px 2px;background-color:#062134;border-radius:6px;display:flex;justify-content:center;gap:4px"><div style="display:flex;justify-content:center">' + marker_img + '</div><div style="font-family:Manrope;color:#FFF;">' + marker_label + '</div></div>';
            map_data.markers.push(new mapboxgl.Marker(el)
                .setLngLat(item_marker_coords)
                .setPopup(new mapboxgl.Popup({ offset: 15 })
                    .setHTML('<p style="font-family:Manrope">' + title_txt + infos_txt + '</p>'))
            )
        }
    }

    // Check data exists
    if (!layer_data.features.length > 0) {
        return map_data
    }

    // Create sources
    map_data.sources.push(
        {
            id: sources_ids[0],
            value: {
                type: 'geojson',
                data: layer_data
            }
        }
    )

    // Create layers
    map_data.layers.push(
        {
            id: layers_ids[0],
            type: 'fill',
            source: sources_ids[0],
            paint: {
                'fill-color': '#062134',
                'fill-opacity': 0.5,
            },
            filter: ['in', '$type', 'Polygon']
        }
    );

    // Set global markers
    if (map_data.markers.length > 0) {
        markers = map_data.markers;
    }
    else {
        markers = [];
    }

    // Get bbox
    var bbox_data = {
        type: 'FeatureCollection',
        features: layer_data.features.concat([capacity?.landBase?.union?.geometry]),
    };
    var bbox = turf.bbox(bbox_data);
    if (bbox && bbox.length === 4) {
        var bbox_poly = [
            [bbox[0], bbox[1]],
            [bbox[2], bbox[1]],
            [bbox[2], bbox[3]],
            [bbox[0], bbox[3]],
            [bbox[0], bbox[1]],
        ]
        map_data.bbox = [bbox_poly];
    }


    // Return
    // console.log("map_data", map_data);
    return map_data

}

